

import { createSelector } from '@reduxjs/toolkit';

const NAME = 'ownershipType';

export const isLoading = state => state[NAME].isLoading

export const list = state => state[NAME].list

export const selectedId = state => state[NAME].selected

export const selected = createSelector(
  list,
  selectedId,
  (_, props) => props && props.id,
  (_list, _selectedId, _id) => _list[_id || _selectedId] 
)